import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import TrialStatusContent from "./TrialStatusContent";

interface TrialStatusModalProps {
  isOpen: boolean;
  onClose: () => void;
  daysRemaining: number;
  onSubscribe: (plan: "monthly" | "yearly" | "lifetime") => void;
}

export default function TrialStatusModal({
  isOpen,
  onClose,
  daysRemaining,
  onSubscribe,
}: TrialStatusModalProps) {
  /*
  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 z-[200] flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm"
          onClick={onClose}
        >
          <motion.div
            initial={{ scale: 0.9, opacity: 0, y: 20 }}
            animate={{ scale: 1, opacity: 1, y: 0 }}
            exit={{ scale: 0.9, opacity: 0, y: 20 }}
            transition={{ type: "spring", damping: 25, stiffness: 300 }}
            onClick={(e) => e.stopPropagation()}
          >
            <TrialStatusContent
              daysRemaining={daysRemaining}
              onSubscribe={onSubscribe}
              onClose={onClose}
            />
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
  */
  return null;
}
